import React,{useState,useEffect} from 'react';
import { Link ,useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { useNavigate } from "react-router-dom";
import Popover from '../admin/shared/Popover';
import SucessMessage from './shared/SucessMessage';

function EditProduct() {

  const { productId } = useParams();
  const [models, setModelData] = useState([]);
  const navigate = useNavigate();
  const [productData,setProductsData]= useState({});
  const [previewImage, setPreviewImage] = useState(null); // preview
  const [isEditMode, setIsEditMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [selectedPopoverId, setSelectedPopoverId] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const [formData, setFormData] = useState({
    id:"",
    name: "",
    modal: "",
    image: null,
  });

  useEffect(() => {
    // Fetch data from the API
   if (productId) {
      setIsEditMode(true);
    
    }
    axios.post(`${config.backendUrl}/admin/models`)
    .then(response => {
      // Handle response
      setModelData(response.data.data);

      console.log(models);
    })
    .catch(error => {
      // Handle error
      console.error('Error:', error);
    });
    fetchProductData();
  
  }, []); // Empty dependency array means this effect runs only once on component mount

  const fetchProductData = async()=>{
    let editProductData = {"product_id":productId};
    const response = await axios.post(`${config.backendUrl}/admin/products/get`,editProductData, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      });
      
      console.log('productData  response:', response.data);
      setProductsData(response.data.data);
      setFormData({ 
        id:response.data.data.id,
        name: response.data.data.name || "",
        modal: response.data.data.modal || "",
        image: null,
    });
     setPreviewImage(response.data.data?.imageUrl || null); // existing product image
  }
  
  const [errors,setErrors] = useState(
    {productName: '',
    modelName: '',
    image: '',});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

   const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
   
    // Check if a file is selected
    if (!selectedFile) {
   
      return;
    }

    // Check if the selected file is an image
    if (!selectedFile.type.startsWith('image/')) {
      setErrors({ ...errors, image: 'Please select an image file.' });
      return;
    }
      setErrors({ ...errors, image: '' });

    // Read the selected image file and set preview image
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedFile);
    setFormData({ ...formData, image: selectedFile });
    // Reset error message and set image file
    setErrorMessage('');
    
  };

  const handleSubmit = async (event) => {
   
    
    event.preventDefault();
    if (!isEditMode && !formData.image) {
      setErrors({
        ...errors,
        image: 'Please select a file',
      });
      return;
    }
    if (!formData.name) {
      setErrors({
        ...errors,
        name: 'Please enter  product name',
      });
      return;
    }
    if (!formData.modal) {
      setErrors({
        ...errors,
        modal: 'Please select model name',
      });
      return;
    }
    
    const formDataToSend = new FormData();
     formDataToSend.append('id', formData.id);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('modal', formData.modal);
    formDataToSend.append('image', formData.image);

    try {
      await axios.put(`${config.backendUrl}/admin/product/update`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      // Handle success
      // navigate('/admin/products'); 
      console.log('File uploaded successfully');
        setSelectedPopoverId(true);
    } catch (error) {
      // Handle error
      console.error('Error uploading file:', error);
    }
    console.log('Form Data:', formData);
    // Clear form fields and file input
    // setFormData({
    //   name: '',
    //   modal: '',
    //   image: null,
    // });
    setErrors({
      name: '',
      modal: '',
      image: '',
    });
  };

 const handleOpenPopover = () => {
    setSelectedPopoverId(true);
  
  };



  const handleClosePopover = () => {
  
    setSelectedPopoverId(false);

    navigate("/admin/products");
  };



  return (
    <> 
     {selectedPopoverId && (
              <Popover onClose={handleClosePopover}  isVisible={selectedPopoverId !== null}>
              
                        
           <SucessMessage>
    
              <h4>Product updated <br/> 
              Successfully</h4>
            </SucessMessage>
    
              </Popover>
            )}
    <div className='pt-[70px]'> 
      <h2>Products</h2>
      <div className="breadcrumbs">
        {" "}
        <Link to="/admin/dashboard">Home</Link>
        <span>{">"}
          </span>
          <Link to="/admin/products">Products</Link>
           <span>{">"}</span>Edit Product{" "}
      </div>
      </div>

      <div className='whitebox uploadproductpop' >
      <div className="container mx-auto p-4">
      <div className="flex flexwrapcol -mx-2 lg:gap-10">
       
        {/* Column 1 */}
       
        <div className="w-full md:w-1/2 px-2 mb-4"> 
        <h2>Edit Product</h2>
       
        <form onSubmit={handleSubmit}>
          <div className="flex items-center mb-6">
          <label className="block text-sm   leading-5  w-1/2" htmlFor="productName">
            Product Name
          </label>
         <div className="block w-full "> <input name="name"  value={formData.name}  onChange={handleInputChange} className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline" />
          {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
          </div>

          </div>
        
          <div className="flex items-center mb-6">
          <label className="block text-sm   leading-5  w-1/2"  htmlFor="modalName">
            Model
          </label>
         <div className="block w-full">
          <select name="modal"  value={formData.modal}   onChange={handleInputChange} className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-900" >
          <option value="" className="text-gray-900 bg-white">Select a model</option>
          {models.map((model, index) => (
            <option key={index} value={model.id} className="text-gray-900 bg-white">{model.model}</option>
          ))}
          </select>
             
          {errors.modal && <p style={{ color: 'red' }}>{errors.modal}</p>}</div> 

          </div>
          <div className="flex items-center mb-6">
        <label className="block text-sm   leading-5 w-1/2">Update Image</label>
        {/* <div className="block relative w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
        
          <input
            type="file" name="image"
            onChange={handleFileChange} 
            multiple
            accept=".jpg,.jpeg,.png" // Adjust accordingly for image files
            style={{ opacity: "0", position:"absolute",width:"100%" }} // Hide the default file input
            id="file-upload" // Id for the label
          />
          
         
          <label htmlFor="file-upload" className="flex justify-between items-center">
         <div> Upload Image(s) </div>  <button style={{height:"20px", width:"100px"}} className='redbtn'> Browse</button>
          </label>
        
         
        
        </div> */}
           <div className="block relative w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
          {/* Your input to accept files */}
          <input
            type="file" name="image"
            onChange={handleImageChange } 
            multiple
            accept=".jpg,.jpeg,.png" // Adjust accordingly for image files
            style={{ opacity: "0", position:"absolute",width:"100%" }} // Hide the default file input
            id="file-upload" // Id for the label
          />
         
          {/* Label to trigger the hidden file input */}
          <label htmlFor="file-upload" className="flex justify-between items-center">
            <div> Upload Image </div>  
            <button style={{height:"20px", width:"100px"}} className='redbtn'> Browse</button>
              </label>
              {previewImage && <img src={previewImage} alt="Preview" style={{ maxWidth: "100%", maxHeight: "200px" }} />}
              {/* List of uploaded images */}
             {errors.image && (
                <p style={{ color: 'red', marginTop: '5px', fontSize: '13px' }}>
                  {errors.image}
                </p>
             )}
        </div>
          </div>
          
         
          <div className="flex items-center mb-6">
            <label className="block text-sm   leading-5  w-1/2 "> 
            </label>
            <div  className="block w-full"> 
            <button className="redbtn" type="submit">
              Update Product
            </button>
          </div>
          </div>
          </form>
        </div>
     
      
      </div>
    </div>
      </div>
    
    </ >
  )
}

export default EditProduct